export default __webpack_public_path__ + "static/rowDragging-570f1340ef8a0678732412d37c932e74.gif";